export const SET_PRICE = 'SET_PRICE'

export const SET_STEP_NUMBER = 'SET_STEP_NUMBER'
export const SET_STEP_AMOUNT = 'SET_STEP_AMOUNT'
export const SET_SUB_STEP = 'SET_SUBSTEP'
export const SET_STEP = 'SET_STEP'
export const SET_CHOICES = 'SET_CHOICES'
export const SET_POPUP = 'SET_POPUP'
export const SET_LOADING = 'SET_LOADING'
export const SET_SUCCESS = 'SET_SUCCESS'
export const SET_SCROLL = 'SET_SCROLL'
export const SET_RESIZE = 'SET_RESIZE'
export const SET_KEY = 'SET_KEY'
export const SET_ADD_TO_CART_CHECK = 'SET_ADD_TO_CART_CHECK'
export const SET_PAYMENTS = 'SET_PAYMENTS'
export const SET_NUMBEROFPAYMENTS = 'SET_NUMBEROFPAYMENTS'